import { IPortabilityMobileCMS } from '@vfit/consumer/data-access';
import { purify } from '@vfit/shared/themes';

const getValidationByID = (editorialConfigs, id: string) => {
  const parser = new DOMParser();
  const value = editorialConfigs?.find((e) => e.id === id)?.value || '';
  const doc = parser.parseFromString(purify([value || ''])?.[0] || '', 'text/html');
  return doc?.body?.textContent?.replace('\n', '') || '';
};

const organizePortabilityNumberCard = (portabilityNumberCardCMS: IPortabilityMobileCMS) => ({
  title: portabilityNumberCardCMS?.portabilitymobile?.telephone?.title || '',
  description: portabilityNumberCardCMS?.portabilitymobile?.telephone?.description || '',
  label: portabilityNumberCardCMS?.portabilitymobile?.selectInput?.telephone || '',
  validationMessage: {
    phoneNumber: {
      required:
        getValidationByID(
          portabilityNumberCardCMS?.editorialconfigs?.elements,
          'phoneNumberRequired'
        ) || 'Inserire un numero di telefono valido',
      minumum:
        getValidationByID(portabilityNumberCardCMS?.editorialconfigs?.elements, 'phoneNumberMin') ||
        'Inserire un numero di telefono valido',
      maximum:
        getValidationByID(portabilityNumberCardCMS?.editorialconfigs?.elements, 'phoneNumberMax') ||
        'Inserire un numero di telefono valido',
      matches:
        getValidationByID(
          portabilityNumberCardCMS?.editorialconfigs?.elements,
          'phoneNumberMatches'
        ) || 'Inserire un numero di telefono valido',
    },
  },
});

const organizePortabilityError = (portabilityNumberCardCMS: IPortabilityMobileCMS) => ({
  titleError: portabilityNumberCardCMS?.portabilitymobile?.errorModal?.title || '',
  messageError: portabilityNumberCardCMS?.portabilitymobile?.errorModal?.message || '',
});

export { organizePortabilityError, organizePortabilityNumberCard };
